import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";

const LmsServicingRequestInspections = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <LmsTable
      apiSuffix="/inspections/request-inspections"
      columnLabelsDictionary={{
        borrowerOrganization: "Borrower",
      }}
      columnClickOptions={{
        name: {
          idProp: "id",
          path: "/servicing-draws/edit/{id}",
        },
      }}
      actionButtons={[
        "export",
        {
          action: "submitselected",
          text: "Order Draw Inspection",
          submitSuffix: "/draws/order-draw-inspections",
          confirmationMessage:
            "Are you sure you want to Order the Work Inspection for the selected record(s)?",
        },
        {
          action: "submitselected",
          text: "Waive Draw Inspection",
          submitSuffix: "/draws/wave-draw-inspections",
          confirmationMessage:
            "Are you sure you want to Waive the Work Inspection for the selected record(s)?",
        },
        {
          action: "submitselected",
          text: "Order Date Down",
          submitSuffix: "/draws/order-date-down",
          confirmationMessage:
            "Are you sure you want to Order the Date Down for the selected record(s)?",
        },
        {
          action: "submitselected",
          text: "Waive Date Down",
          submitSuffix: "/draws/wave-date-down",
          confirmationMessage:
            "Are you sure you want to Waive the Date Down for the selected record(s)?",
        },
      ]}
    />
  );
};

export default LmsServicingRequestInspections;
